<template>
  <div>
    <v-alert v-if="$vuetify.breakpoint.xsOnly" type="info" text dense class="mx-4 mt-3 mb-2">{{ $t('quotations.mobile_calc_readonly') }}</v-alert>

    <div :class="$vuetify.breakpoint.xsOnly ? 'px-4' : ''">
      <quotation-site-card
        v-for="site in sortedSites"
        :key="site.id || site._key"
        :site="site"
        :sibling-names="siblingNames(site)"
        :work-methods="workMethods"
        :items="items"
        :readonly="readonly"
        :saving="saving"
        @remove="removeSite(site)"
      />

      <no-content-view
        v-if="sortedSites.length === 0"
        :title="$t('quotations.calc.no_sites')"
        :description="readonly ? '' : $t('quotations.calc.no_sites_help')"
        title-icon="mdi-map-marker-outline"
        :reload-button="false"
      />

      <v-btn v-if="!readonly" color="primary" outlined :disabled="saving" class="mb-4" @click="addSite">
        <v-icon left>mdi-plus</v-icon>
        {{ $t('quotations.calc.add_site') }}
      </v-btn>

      <div class="d-flex justify-end align-baseline mb-4 px-2">
        <span class="subtitle-1 mr-4">{{ $t('quotations.total_vat0') }}</span>
        <span class="headline font-weight-bold">{{ $formatNumber(total, '0,0.00') }} €</span>
      </div>
    </div>
  </div>
</template>

<script>
import QuotationSiteCard from './QuotationSiteCard';
import NoContentView from '@/components/NoContentView';
import { quotationTotal } from '@/helpers/quotationCalc';

export default {
  name: 'QuotationCalculationTab',
  components: { QuotationSiteCard, NoContentView },
  props: {
    quotation: { type: Object, required: true },
    workMethods: { type: Array, default: () => [] },
    items: { type: Array, default: () => [] },
    readonly: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
  },
  computed: {
    sortedSites() {
      return [...(this.quotation.sites || [])].sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
    },
    total() {
      return quotationTotal(this.quotation);
    },
  },
  methods: {
    siblingNames(site) {
      return (this.quotation.sites || []).filter(s => s !== site).map(s => s.name);
    },
    addSite() {
      const sites = [...(this.quotation.sites || [])];
      const maxOrder = Math.max(0, ...sites.map(s => s.sortOrder || 0));
      sites.push({ _key: this.$randomString(), name: '', address: '', geocoding: { lat: null, lng: null, address: '' }, additionalInfo: '', soilTypes: [], sortOrder: maxOrder + 10, rows: [] });
      this.$set(this.quotation, 'sites', sites);
    },
    removeSite(site) {
      const works = (site.rows || []).filter(r => r.rowType === 'WORK').length;
      const rows = (site.rows || []).length;
      this.$confirmDelete(this.$t('quotations.calc.delete_site_confirm', { name: site.name || '–', works, rows }), this.$t('quotations.calc.delete_site')).then(confirm => {
        if (confirm) {
          this.$set(
            this.quotation,
            'sites',
            (this.quotation.sites || []).filter(s => s !== site),
          );
        }
      });
    },
  },
};
</script>
